import React, { useState } from 'react';
import {
  AlertBanner,
  Box,
  Button,
  Icon,
  Logo,
  Typography,
} from '@saviynt/design-system';

import useGetIDPURL from '../../../../hooks/use-getidpurl';
import { useInvertedLocalize } from '../../../../utils';
import { ERROR_MESSAGE } from '../../../../utils/constants';

import invertedMessages from './messages';

import './IDPAnonymous.css';

export default function IDPAnonymous() {
  const l = useInvertedLocalize(invertedMessages);
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorBanner, setShowErrroBanner] = useState(false);
  const [isDisableIDProofingBtn, setIsDisableIDProofingBtn] = useState(false);
  const { mutate: getIDPURL, isPending } = useGetIDPURL();
  const params = new URLSearchParams(window.location.search);
  const key = params.get('key') ?? '';

  const startIdProofingHandler = () => {
    getIDPURL(key, {
      onSuccess(response) {
        if (!response.ok && response.status !== 0) {
          setErrorMessage(
            response.error.errorMessage ??
              response.errorMessage ??
              response.error.idProofingUrl ??
              ERROR_MESSAGE
          );
          setIsDisableIDProofingBtn(true);
          setShowErrroBanner(true);
        } else {
          const { idProofingUrl } = response;

          if (idProofingUrl) {
            window.open(idProofingUrl, '_blank');
          }
        }
      },
    });
  };

  return (
    <Box className='Ext-IDP-anonymousPage'>
      <header>
        <Logo />
      </header>
      <AlertBanner
        colorTheme='Critical'
        title={errorMessage}
        description=''
        isVisible={showErrorBanner}
        onCancel={() => setShowErrroBanner(false)}
        isColonVisible={false}
      />
      <div className='Ext-IDP-anonymousPage-content'>
        <Typography
          kind='display'
          color='--color-foreground-secondary-bold'
          className='Ext-IDP-anonymousPage-content-welcomeText'>
          {l('Welcome to ID Proofing')}
        </Typography>
        <Typography
          kind='body1'
          color='--color-foreground-neutral-subtle'
          className='Ext-IDP-anonymousPage-content-subText'>
          {l(
            'To begin the ID proofing process, you will be securely redirected to Identity Proofing website to complete your identity verification.'
          )}
        </Typography>
        <div className='Ext-IDP-anonymousPage-content-btn'>
          <Button
            kind='filled'
            size='medium'
            isLoading={isPending}
            loaderText={l('Start ID Proofing')}
            rightIcon={<Icon kind='ArrowRight' />}
            isDisabled={isPending || isDisableIDProofingBtn}
            onClick={startIdProofingHandler}>
            {l('Start ID Proofing')}
          </Button>
        </div>
      </div>
    </Box>
  );
}
